module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side"
  }, [_c('desktop-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main"
  }, [_c('div', {
    staticClass: "card crd-header"
  }, [_c('desktop-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-desktop-body"
  }, [_c('component-items')], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e32be5c6"}!./src/pages/Settings/desktop/desktop.html
// module id = 627
// module chunks = 0